<template>
  <v-container>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />

    <v-form ref="form" lazy-validation>
      <v-row align="center">
        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-text-field
            :rules="[rules.required, rules.maxvalue]"
            v-model="userDetail.firstname"
            class="mx-3"
            label="First Name"
            outlined
            dense
            @keyup.enter="submit"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-text-field
            :rules="[rules.required, rules.maxvalue]"
            v-model="userDetail.lastname"
            class="mx-3"
            label="Last Name"
            outlined
            dense
            @keyup.enter="submit"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-text-field
            :rules="[rules.required, rules.maxvalue]"
            v-model="userDetail.email"
            class="mx-3"
            label="Email"
            outlined
            dense
            @keyup.enter="submit"
          ></v-text-field>
        </v-col>
        <!-- <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-text-field
            :rules="[rules.required, rules.maxvaluePhone, rules.onlynumber]"
            v-model="userDetail.phonenumber"
            class="mx-3"
            label="Phone Number"
            outlined
            dense
            @keyup.enter="submit"
          ></v-text-field>
        </v-col> -->
        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-select
            :rules="[rules.required]"
            v-model="userDetail.lang.langid"
            class="mx-3"
            :items="langList"
            dense
            label="Lang"
            outlined
            item-text="langname"
            item-value="langid"
          ></v-select>
        </v-col>
        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-select
            v-model="userDetail.isadmin"
            class="mx-3"
            :items="userType"
            outlined
            dense
            label="User Rule"
            item-text="name"
            @change="selectRule"
            item-value="value"
          ></v-select>
        </v-col>
        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-autocomplete
            v-model="userDetail.categories"
            :items="userDetail.categories"
            outlined
            dense
            :readonly="true"
            chips
            class="mx-3"
            small-chips
            label="Categories"
            multiple
            item-text="categoryname"
            item-value="categoryid"
            @focus="dialogCategoryTree = true"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-row align="center">
            <v-col cols="6" class="pt-0 pb-0">
              <v-switch
                class="mx-3"
                v-model="userDetail.status"
                label="Status"
                color="primary"
                hide-details
              ></v-switch>
            </v-col>

            <v-col cols="6" class="pt-0 pb-0">
              <v-btn
                @click="submit"
                depressed
                color="primary"
                class="float-right mr-3 mt-3"
                :loading="loadingEdit"
              >
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-switch
            class="mx-3"
            v-model="changePassword"
            label="Change Password"
            color="primary"
            hide-details
          ></v-switch>
          <div v-if="changePassword">
            <v-text-field
              :rules="[rules.required, rules.maxvalue]"
              @keyup.enter="submit"
              v-model="password"
              class="mx-3 mt-6"
              label="Password"
              type="Password"
              outlined
              dense
            ></v-text-field>

            <v-text-field
              :rules="[rules.required, rules.maxvalue, rules.paswordconfirm]"
              @keyup.enter="submit"
              v-model="confirmPassword"
              class="mx-3"
              label="Password Confirm"
              outlined
              type="Password"
              dense
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
    </v-form>
    <AdminConfirm
      :AdminConfirmDialog="AdminConfirmDialog"
      v-on:closeAdminConfirmDialog="closeAdminConfirmDialog($event)"
    />
    <SelectTreeCategory
      v-if="userDetail.email != ''"
      :selectedCategories="selectedCategories"
      :dialogCategoryTree="dialogCategoryTree"
      v-on:closeCatDialog="closeCategory($event)"
      v-on:closeCatDialogWithCategories="
        closeCatDialogWithCategoriesMethod($event)
      "
    />
  </v-container>
</template>
<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
import AdminConfirm from "@/components/User/AdminConfirm";
import SelectTreeCategory from "@/components/Category/SelectTreeCategory";
export default {
  data() {
    return {
      rules: {
        required: (value) => !!value || "Field required.",
        maxvalue: (value) =>
          value.length <= 32 || "Maximum length is 32 characters",
        maxvaluePhone: (value) =>
          value.length <= 20 || "Maximum length is 20 characters",
        onlynumber: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0) || "Value Only Number",
        paswordconfirm: () =>
          this.password == this.confirmPassword || "password not confirm",
      },

      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/",
        },
        {
          text: "Users",
          disabled: false,
          to: "/users",
        },
        {
          text: "Edit User",
          disabled: true,
        },
      ],
      loadingEdit: false,
      changePassword: false,
      dialogCategoryTree: false,
      AdminConfirmDialog: false,
      langList: [],
      userType: [
        { name: "Admin", value: true },
        { name: "User", value: false },
      ],
      userDetail: {
        firstname: "",
        lastname: "",
        email: "",
        phonenumber: "",
        lang: {
          langid: "",
        },
      },
      selectedCategories: [],
      password: "",
      confirmPassword: "",
    };
  },
  components: {
    Breadcrumbs,
    SelectTreeCategory,
    AdminConfirm,
  },
  mounted() {
    this.getAllLang();
    this.getUserDetail();
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() != false) {
        this.loadingEdit = true;
        let DataForm = {
          Param: {
            firstname: this.userDetail.firstname,
            lastname: this.userDetail.lastname,
            email: this.userDetail.email,
            phonenumber: this.userDetail.phonenumber || '1111111111',
            langid: this.userDetail.lang.langid,
            status: this.userDetail.status,
            isadmin: this.userDetail.isadmin,
            category: [],
          },
          API: "/admin/user/" + this.$route.params.userID,
        };
        if (this.changePassword == true) {
          DataForm.Param.password = this.password;
        }

        if (!this.userDetail.categories == []) {
          for (
            let index = 0;
            index < this.userDetail.categories.length;
            index++
          ) {
            DataForm["Param"]["category"].push(
              this.userDetail.categories[index]["categoryid"]
            );
          }
        }
        this.$store
          .dispatch("PutToAPI", DataForm)
          .then((response) => {
            this.$store.dispatch("PushSuccessMsg", response.data.message);
            this.loadingEdit = false;
          })
          .catch((error) => {
            let errorObj = error.data.data;
            this.loadingEdit = false;
            this.$store.dispatch(
              "PushErrorMsg",
              errorObj[Object.keys(errorObj)[0]][0]
            );
          });
      } else {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      }
    },
    getUserDetail() {
      this.$store
        .dispatch("GetFromAPI", "/admin/user/" + this.$route.params.userID)
        .then((response) => {
          this.userDetail = { ...response["data"]["data"] };
          this.selectedCategories = this.userDetail.categories;
        });
    },
    getAllLang() {
      this.$store.dispatch("GetFromAPI", "/admin/lang").then((response) => {
        this.langList = response["data"]["data"];
      });
    },
    selectRule() {
      if (this.userDetail.isadmin == 1) {
        this.AdminConfirmDialog = true;
      }
    },
    closeCatDialogWithCategoriesMethod(vals) {
      this.dialogCategoryTree = false;
      this.userDetail.categories = vals;
    },
    closeCategory() {
      this.dialogCategoryTree = false;
    },
    closeAdminConfirmDialog(AcceptVal) {
      if (AcceptVal == false) {
        this.userDetail.isadmin = false;
      }
      this.AdminConfirmDialog = false;
    },
  },
};
</script>

